import { render, staticRenderFns } from "./ComputersVerified.vue?vue&type=template&id=012f02d1&"
import script from "./ComputersVerified.vue?vue&type=script&lang=js&"
export * from "./ComputersVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports